/** @type {import('@nuxt/types').Plugin} */
export default (context, inject) => {
    /**
     * @param {number} timestamp
     * @return {string}
     */
    function localeDate(timestamp) {
        if (!timestamp) {
            return '';
        }

        const { store } = context;
        const date = new Date(timestamp);
        return date.toLocaleDateString(store.state.userLocale);
    }

    inject('localeDate', localeDate);
};
